import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TOEFLTOPLogo from "../../assets/TOEFLTOPLogo.png";
import { useAuth } from "../../contexts/AuthContext";
import styled from "styled-components";

const MobileMenuButton = styled.button`
  display: none;
  color: white;
  background: none;
  border: none;
  font-size: 1.9rem;
  cursor: pointer;


  @media (max-width: 768px) {
    display: block;
  }
`;

const NavLinks = styled.nav`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    flex-direction: column;
    position: absolute;
    top: 4rem;
    right: 0;
    background: black;
    width: 100%;
    padding: 1rem;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    border-radius: 0 0 4px 4px;
    gap: 1rem;
    margin-right: 0;
  }
`;

const AuthButtons = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
    width: 100%;
  }
`;

const Header = ({ onHeaderLink }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const timeoutRef = React.useRef(null);
  const menuRef = React.useRef(null);

  // Add click outside handler
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Add inactivity timer
  React.useEffect(() => {
    if (isMenuOpen) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setIsMenuOpen(false);
      }, 3000);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [isMenuOpen]);

  // Add mouse movement reset timer
  const resetTimer = () => {
    if (isMenuOpen) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setIsMenuOpen(false);
      }, 3000);
    }
  };

  const handleLogout = async () => {
    await logout();
    localStorage.clear();
  };

  const handleClickLogin = () => {
    navigate("/login");
    setIsMenuOpen(false);
  };

  const handleClickRegister = () => {
    navigate("/register");
    setIsMenuOpen(false);
  };

  const handleNavClick = (section) => {
    onHeaderLink(section);
    setIsMenuOpen(false);
  };

  return (
    <div className="header" style={{ width: '100%', position: 'fixed' }}>
      <div className="logo" onClick={() => (window.location.href = "/")} style={{ cursor: 'pointer' }}>
        <img className="logo-icon" src={TOEFLTOPLogo} alt="TOEFL Top Logo" />
        <div className="logo-text">TOEFL Top</div>
      </div>
      
      <MobileMenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
        ☰
      </MobileMenuButton>

      <NavLinks isOpen={isMenuOpen} ref={menuRef} onMouseMove={resetTimer}>
        <p
          className="nav-link"
          onClick={() => handleNavClick("free-resources")}
          style={{ cursor: 'pointer' }}
        >
          Free Resources
        </p>
        <p className="nav-link" onClick={() => handleNavClick("coaching")} style={{ cursor: 'pointer' }}>
          Coaching
        </p>
        <p className="nav-link" onClick={() => handleNavClick("testimonials")} style={{ cursor: 'pointer' }}>
          Testimonials
        </p>
        {user ? (
          <p className="nav-link" onClick={handleLogout} style={{ cursor: 'pointer' }}>
            Logout
          </p>
        ) : (
          <AuthButtons>
            <p className="nav-link" onClick={handleClickLogin} style={{ cursor: 'pointer' }}>
              Login
            </p>
            <p className="nav-link" onClick={handleClickRegister} style={{ cursor: 'pointer' }}>
              Sign Up
            </p>
          </AuthButtons>
        )}
      </NavLinks>
    </div>
  );
};

export default Header;
